import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./FeeStatementFilter.css";
import { API_URL, secret_key, storedData } from './Constants';
import CryptoJS from 'crypto-js';
import { Filter } from "lucide-react";

export default function FeeStatementFilter() {
  const navigate = useNavigate();

  // --- Decrypt User Data ---
  let loggedUserData = null;
  if (storedData) {
    try {
      const bytes = CryptoJS.AES.decrypt(storedData, secret_key);
      loggedUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (err) {
      console.error("User data decryption error:", err);
    }
  }
    // --- Decrypt Token & User Data ---
    const encryptedToken = localStorage.getItem('token');
    let decryptedToken = '';
    if (encryptedToken) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
        decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.error('Token decryption error:', error);
      }
    }
    const token = `Bearer ${decryptedToken}`;

  const [siblings, setSiblings] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), 0, 1));
  const [endDate, setEndDate] = useState(new Date());
  const [loading, setLoading] = useState(false);

  // Load students only once on mount
  useEffect(() => {
    if (!loggedUserData?.company_id || !loggedUserData?.parent_no) return;

    setLoading(true);
    axios
      .get(`${API_URL}/students/${loggedUserData.company_id}/${loggedUserData.parent_no}`,
            {
              headers: {
              Authorization: `CustomToken ${secret_key}`,
            },
            }
      )
      .then((res) => {
        if (res.data.success) setSiblings(res.data.details || []);
        else console.warn("API returned success = false:", res.data);
      })
      .catch((err) => {
        console.error("Error loading students:", err);
        alert("Error loading students. Check console.");
      })
      .finally(() => setLoading(false));
  }, []); // run only once

const handleProceed = () => {
  if (!selectedStudent) return alert("Please select a student.");

  const from = startDate.toISOString().split("T")[0];
  const to = endDate.toISOString().split("T")[0];
  const dateFilter = `${from}_${to}`;

  const company_id = loggedUserData?.company_id;
  const parent_no = loggedUserData?.parent_no;

  if (!company_id || !parent_no) {
    return alert("Company ID or Parent No missing!");
  }

navigate(
  `/fee_statement/${company_id}/${parent_no}/${selectedStudent}/${dateFilter}`,
  {
    state: { auth: secret_key }  // 🔒 safe
  }
);


};


  return (
    <div className="fee-filter-container">
            <h2 className="fee-filter-title flex items-center gap-2">
              <Filter size={20} />
              Fee Statement Filter
            </h2>
      <p className="fee-filter-subtitle">
        Select a student and date range to generate the statement
      </p>

      {loading ? (
        <div className="fee-filter-loading">Loading students...</div>
      ) : siblings.length === 0 ? (
        <div className="fee-filter-no-students">No students found for your account.</div>
      ) : (
        <div className="fee-filter-grid">
          {/* Left Column */}
          <div className="fee-filter-column">
            <label className="fee-filter-label">Select Student</label>
            <select
              className="fee-filter-select"
              value={selectedStudent}
              onChange={(e) => setSelectedStudent(e.target.value)}
            >
              <option value="">-- Choose Student --</option>
              {siblings.map((s, i) => (
                <option key={i} value={s.admission_no}>
                  {s.full_name} ({s.admission_no})
                </option>
              ))}
            </select>
          </div>

          {/* Right Column */}
          <div className="fee-filter-column">
            <label className="fee-filter-label">From</label>
            <input
              type="date"
              className="fee-filter-input"
              value={startDate.toISOString().split("T")[0]}
              onChange={(e) => setStartDate(new Date(e.target.value))}
            />
            <label className="fee-filter-label mt-2">To</label>
            <input
              type="date"
              className="fee-filter-input"
              value={endDate.toISOString().split("T")[0]}
              onChange={(e) => setEndDate(new Date(e.target.value))}
            />
          </div>
        </div>
      )}

      <div className="fee-filter-actions">
        <button
          onClick={() => navigate(-1)}
          className="fee-filter-button back-button"
        >
          ← Back
        </button>
        <button
          onClick={handleProceed}
          disabled={loading || siblings.length === 0}
          className="fee-filter-button proceed-button"
        >
          {loading ? "Loading..." : "Proceed"}
        </button>
      </div>
    </div>
  );
}
